// const BASE_URL = 'http://119.3.210.33:7002'
const BASE_URL = 'https://api.yoojet.com'
// const BASE_URL = 'http://192.168.1.111:5000'
export default {
  BASE_URL,
}
